/* window resize  code for header menu */
function resizeWindow() {
    var pageHeader = document.querySelector(".pageheader"),
      inlineNavContainer = pageHeader.querySelector(".logo-area__left__inner"),
      inlineNav = inlineNavContainer.querySelector(".navigation--left");
    if (inlineNav && getComputedStyle(inlineNav).display != "none") {
      var inlineMenuCentered = document.querySelector(
          ".pageheader--layout-inline-menu-center"
        ),
        logoContainer = document.querySelector(".logo-area__middle__inner");
      if (inlineMenuCentered) {
        var rightWidth = document.querySelector(
            ".logo-area__right__inner"
          ).clientWidth,
          middleWidth = logoContainer.clientWidth,
          logoArea = document.querySelector(".logo-area"),
          computedLogoAreaStyle = getComputedStyle(logoArea),
          logoAreaInnerWidth =
            logoArea.clientWidth -
            Math.ceil(parseFloat(computedLogoAreaStyle.paddingLeft)) -
            Math.ceil(parseFloat(computedLogoAreaStyle.paddingRight)),
          availableNavWidth =
            logoAreaInnerWidth - Math.max(rightWidth, middleWidth) * 2 - 40;
        inlineNavContainer.style.maxWidth = availableNavWidth + "px";
      }
  
      var lastInlineNavLink = inlineNav.querySelector(
        ".navigation__item:last-child"
      );
      if (lastInlineNavLink) {
        var inlineNavWidth =
          lastInlineNavLink.offsetLeft + lastInlineNavLink.offsetWidth;
        if (inlineNavContainer.offsetWidth >= inlineNavWidth) {
          pageHeader.classList.add("pageheader--layout-inline-permitted");
          var tallLogo =
            logoContainer.clientHeight > lastInlineNavLink.clientHeight + 1;
          if (tallLogo) {
            inlineNav.classList.add("navigation--tight-underline");
          } else {
            inlineNav.classList.remove("navigation--tight-underline");
          }
        } else {
          pageHeader.classList.remove("pageheader--layout-inline-permitted");
        }
      }
    }
  }
  $(window).resize(function () {
    resizeWindow();
  });
  /* end  window resize code for header menu */
  
  $(document).ready(function () {
    $(".show-search-link").click(function () {
      $(".main-search").css({
        opacity: "1",
        visibility: "visible",
        "z-index": "999",
        "pointer-events": "all",
      });
    });
  
    $(".main-search__close").click(function () {
      $(".main-search").css({
        opacity: "0",
        visibility: "hidden",
        "z-index": "0",
        "pointer-events": "none",
      });
    });
  
    $("#pageheader, #main-nav")
      .on(
        "mouseenter",
        ".navigation__tier-1 > .navigation__item--with-children",
        function (evt) {
          $("#main-nav .navigation__tier-1 > .navigation__item").removeClass(
            "navigation__item--show-children"
          );
          $(
            $("#main-nav .navigation__tier-1 > .navigation__item")[
              $(this).index()
            ],
            $(this)
          ).addClass("navigation__item--show-children");
        }
      )
      .on(
        "mouseleave",
        ".navigation__tier-1 > .navigation__item--with-children",
        function (evt) {
          $("#main-nav .navigation__tier-1 > .navigation__item").removeClass(
            "navigation__item--show-children"
          );
        }
      );
  
    $(document).on("click", ".mobile-nav-toggle", function (e) {
      e.preventDefault();
  
      if ($("body").hasClass("enable-mobile-nav-transition")) {
        $("body").removeClass("reveal-mobile-nav");
        setTimeout(function () {
          $("body").removeClass("enable-mobile-nav-transition");
        }, 750);
      } else {
        $("body").addClass("enable-mobile-nav-transition");
        setTimeout(function () {
          $("body").addClass("reveal-mobile-nav"); // on reveal, set up internal transition values
  
          $(".mobile-navigation-drawer .disclosure").each(function () {
            var $list = $(".disclosure-list", this),
              listHeight = 0;
            $list.children().each(function () {
              listHeight += $(this).height();
            });
            $(".disclosure-list", this).css("height", listHeight + "px");
          }); // on reveal, load product carousel
  
          $(".mobile-navigation-drawer .product-list").each(function () {
            theme.ProductBlockManager.loadImages($(this));
          });
        }, 10);
      }
    });
  
    /* $('<a href="#" class="page-shade" aria-label="' + theme.strings.general_navigation_menu_toggle_aria_label + '"></a>').on('click', function () {
              $('body').removeClass('reveal-mobile-nav show-search');
              setTimeout(function () {
                 $('body').removeClass('enable-mobile-nav-transition');
              }, 750);
              return false;
           }).appendTo('body'); */
  
    var $mobileDrawer = $(".mobile-navigation-drawer");
    $mobileDrawer.on(
      "click",
      ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
      function (evt) {
        evt.preventDefault();
        $(this)
          .siblings(".navigation__tier-2-container")
          .css({
            top:
              Math.ceil($(".navigation__mobile-header:last").height() + 1) + "px",
          });
        $(this)
          .parent()
          .addClass("navigation__item--open")
          .closest(".mobile-navigation-drawer")
          .addClass("mobile-navigation-drawer--child-open")
          .find(".mobile-nav-title")
          .text($(this).siblings(".navigation__link").text());
      }
    );
  
    $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
      evt.preventDefault();
      $(this)
        .closest(".mobile-navigation-drawer")
        .removeClass("mobile-navigation-drawer--child-open")
        .find(".navigation__tier-1 > .navigation__item--open")
        .removeClass("navigation__item--open");
    });
  
    $mobileDrawer.on(
      "click",
      ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
      function (evt) {
        evt.preventDefault();
        var doOpen = !$(this).parent().hasClass("navigation__item--open");
        if (doOpen) {
          $(this).parent().addClass("navigation__item--open");
          var $childContainer = $(this).siblings(".navigation__tier-3-container");
          $childContainer.css("height", $childContainer.children().outerHeight());
        } else {
          $(this).parent().removeClass("navigation__item--open");
          $(this).siblings(".navigation__tier-3-container").css("height", "");
        }
      }
    );
  });
  